import React, { useMemo } from 'react';
import { useAppSelector } from 'hooks';

import { Modal } from '~components';
import { Row, TableView } from '~components/table-view-v3';

import columnsFactory from '~support-at-home/forms/budgets/clientBudgetsList';

import { selectClientWithBudgetsById } from '~support-at-home/selectors/clientsWithBudgets';

interface ComponentProps {
  id: number | null | undefined;
  isOpen?: boolean;
  setIsOpen: (val: boolean) => void;
}

const ClientsWithBudgetsModal: React.FC<ComponentProps> = ({ id, isOpen, setIsOpen }) => {
  const client = useAppSelector((state) => selectClientWithBudgetsById(state, id ?? undefined));

  const data: Row[] = useMemo(() => (client?.budgets ?? []) as Row[], [client]);
  const columns = useMemo(() => columnsFactory(), []);

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} size="xl" header={`${client?.full_name}`} headerClassName="header">
      <TableView id="client-with-budgets-modal-table" columns={columns} data={data} readonly striped />
    </Modal>
  );
};

export default ClientsWithBudgetsModal;
